export const userRole = {
  admin: 90,
  collector: 50,
  read_only: 10,
}
